import { useScrollAnimation } from "@/hooks/useScrollAnimation";

const ProblemReframe = () => {
  const { ref, isVisible } = useScrollAnimation();

  return (
    <section className="bg-[hsl(var(--pastel-peach))] py-24 md:py-32 px-6">
      <div
        ref={ref}
        className={`mx-auto max-w-3xl text-center transition-all duration-700 ${
          isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
        }`}
      >
        <h2 className="heading-bold text-3xl leading-[0.95] text-foreground sm:text-5xl lg:text-[4rem]">
          You're not hungry. You're{" "}
          <span className="font-display italic normal-case font-normal">stressed. Tired. Wired.</span>
        </h2>
        <p className="mx-auto mt-6 max-w-xl text-base leading-relaxed text-foreground/70 sm:text-lg">
          Most snacking isn't about hunger — it's about <strong className="text-foreground font-bold">state</strong>. You reach for something because
          you need to focus, unwind, or push through. What if the snack actually helped you do that?
        </p>
      </div>
    </section>
  );
};

export default ProblemReframe;
